import { layersVectorSource } from "./vector-sources";
// import ImageLayer from "ol/layer/Image";
import ImageLayer from "ol/layer/Image";
import VectorImageLayer from "ol/layer/VectorImage";
import { styles } from "./styles";
import { Map } from "ol";
import { ImageWMS } from "ol/source";
import { layerController } from "./layer-controller";
import { SERVER } from "./defaults";

const layers = {
  GNA: {
    punti: new VectorImageLayer({
      title: "Punti",
      source: layersVectorSource.GNA.punti,
      style: styles.multipoint,
      opacity: 1,
      minZoom: 9,
    }),
    linee: new VectorImageLayer({
      title: "Linee",
      extent: [734419, 4225249, 2075207, 5972507],
      source: layersVectorSource.GNA.linee,
      style: styles.multiline,
      opacity: 1,
      minZoom: 9,
    }),
    poligoni: new VectorImageLayer({}),
    poligoni2: new VectorImageLayer({
      title: "Poligoni 2",
      extent: [734419, 4225249, 2075207, 5972507],
      source: layersVectorSource.GNA.poligoni2,
      style: styles.multipolygon,
      opacity: 1,
      minZoom: 9,
    }),
    progetti: new VectorImageLayer({
      title: "Progetti",
      source: layersVectorSource.GNA.progetti,
      style: styles.mopr,
      opacity: 1,
    }),
    ricostruitiLinee: new VectorImageLayer({
      title: "Ricostruiti Linee",
      source: layersVectorSource.GNA.ricostruitiLinee,
      style: styles.r_multiline,
      opacity: 1,
    }),
    ricostruitiPoligoni: new VectorImageLayer({
      title: "Ricostruiti Poligoni",
      source: layersVectorSource.GNA.ricostruitiPoligoni,
      style: styles.r_multipolygon,
      opacity: 1,
    }),
  },
  AltreBancheDati: {
    censimento: new VectorImageLayer({
      title: "Censimento",
      source: layersVectorSource.AltreBancheDati.censimento,
      style: styles.censimento,
      opacity: 1,
      minZoom: 9,
    }),
    tess: new VectorImageLayer({
      title: "Tess",
      source: layersVectorSource.AltreBancheDati.tess,
      style: styles.tess,
      opacity: 1,
      minZoom: 9,
    }),
  },
  Concessione: new VectorImageLayer({
    title: "Concessione",
    source: layersVectorSource.Concessione,
    style: styles.concessioni,
    opacity: 1,
  }),
  ICCD: new VectorImageLayer({
    title: "ICCD",
    source: layersVectorSource.ICCD,
    style: styles.iccd,
    opacity: 1,
    minZoom: 9,
  }),
};

const layersWMS = {
  GNA: {
    multipoint: new ImageLayer({
      title: "punti-wms",
      extent: [734419, 4225249, 2075207, 5972507],
      source: new ImageWMS({
        url: `${SERVER}/ogc/wms`,
        params: {
          LAYERS: "mosi_multipoint",
          STYLES: "Valori unici per categoria",
        },
        ratio: 2,
        // projection: "EPSG:4326",
      }),
      maxZoom: 9,
    }),
    multiline: new ImageLayer({
      title: "linee-wms",
      extent: [734419, 4225249, 2075207, 5972507],
      source: new ImageWMS({
        url: `${SERVER}/ogc/wms`,
        params: {
          LAYERS: "MOSI_multilinea",
          STYLES: "Valori unici per categoria",
        },
        ratio: 1,
      }),
      maxZoom: 9,
    }),
    multipolygon: new ImageLayer({
      title: "poligoni-wms",
      extent: [734419, 4225249, 2075207, 5972507],
      source: new ImageWMS({
        url: `${SERVER}/ogc/wms`,
        params: {
          LAYERS: "MOSI_multipolygon",
          STYLES: "Valori unici per categoria",
        },
        ratio: 1,
      }),
      maxZoom: 9,
    }),
  },
  // Concessione: new ImageLayer({
  //     title: "concessioni-wms",
  //     extent: [734419, 4225249, 2075207, 5972507],
  //     source: new ImageWMS({
  //         url: `${SERVER}/ogc/wms`,
  //         params: {
  //             LAYERS: "concessioni",
  //             STYLES: "concessioni",
  //         },
  //         ratio: 1,
  //     }),
  // }),
  AltreBancheDati: {
    censimento: new ImageLayer({
      title: "censimento-wms",
      extent: [734419, 4225249, 2075207, 5972507],
      source: new ImageWMS({
        url: `${SERVER}/ogc/wms`,
        params: {
          LAYERS: "Censimento_pt",
        },
        ratio: 1,
      }),
      maxZoom: 9,
    }),
    tess: new ImageLayer({
      title: "tess-wms",
      extent: [734419, 4225249, 2075207, 5972507],
      source: new ImageWMS({
        url: `${SERVER}/ogc/wms`,
        params: {
          LAYERS: "Tess_pt",
        },
        ratio: 1,
      }),
      maxZoom: 9,
    }),
  },
  ICCD: new ImageLayer({
    title: "iccd-wms",
    extent: [734419, 4225249, 2075207, 5972507],
    source: new ImageWMS({
      url: `${SERVER}/ogc/wms`,
      params: {
        LAYERS: "CatalogoICCD_pt",
      },
      ratio: 1,
    }),
    maxZoom: 9,
  }),
};

/**
 *
 * @param {Map} map
 */
const addLayers = (map) => {
  // ADDING WMS LAYERS
  map.addLayer(layersWMS.GNA.multipolygon);
  map.addLayer(layersWMS.GNA.multiline);
  map.addLayer(layersWMS.GNA.multipoint);

  map.addLayer(layersWMS.ICCD);
  map.addLayer(layersWMS.AltreBancheDati.censimento);
  map.addLayer(layersWMS.AltreBancheDati.tess);

  // ADDING VECTOR LAYERS
  map.addLayer(layers.GNA.progetti);
  // map.addLayer(layers.GNA.poligoni); // it's obselete in GNA's code
  map.addLayer(layers.GNA.ricostruitiPoligoni);
  map.addLayer(layers.GNA.ricostruitiLinee);
  map.addLayer(layers.GNA.poligoni2);
  map.addLayer(layers.GNA.linee);
  map.addLayer(layers.GNA.punti);

  map.addLayer(layers.Concessione);
  map.addLayer(layers.ICCD);
  map.addLayer(layers.AltreBancheDati.censimento);
  map.addLayer(layers.AltreBancheDati.tess);

  // HIDE LAYERS
  layers.Concessione.setVisible(false);
  layers.ICCD.setVisible(false);
  layers.AltreBancheDati.censimento.setVisible(false);
  layers.AltreBancheDati.tess.setVisible(false);

  // SET WMS LAYERS
  layersWMS.GNA.multiline.setVisible(true);
  layersWMS.GNA.multipoint.setVisible(true);
  layersWMS.GNA.multipolygon.setVisible(true);
  layersWMS.ICCD.setVisible(false);
  layersWMS.AltreBancheDati.censimento.setVisible(false);
  layersWMS.AltreBancheDati.tess.setVisible(false);
};

export { layers, layersWMS, addLayers };
